import { useEffect } from 'react'

/**
 * The staging-only "this is not production" bar (task 04, 04.1).
 *
 * Driven by VITE_STAGING, which only the staging build sets. In production the
 * flag is unset, this renders nothing, and no class is added -- the app is
 * byte-for-byte its normal self. On staging it pins a bright bar across the top
 * and shrinks #root by the bar's height (see styles.css) so the no-scroll shell
 * is preserved rather than overlapped.
 *
 * The whole point is that the seeded staging data can never be mistaken for the
 * real team's, so it is deliberately loud and always present.
 */
export function StagingBanner() {
  const staging = Boolean(import.meta.env.VITE_STAGING)

  useEffect(() => {
    if (!staging) return
    document.body.classList.add('has-staging')
    return () => document.body.classList.remove('has-staging')
  }, [staging])

  if (!staging) return null
  return (
    <div className="staging-banner" role="status">
      STAGING — demo data, not real stats. Have a look around. But why did AI give Lucas the lowest stats?!
    </div>
  )
}
